import {Component, ElementRef, HostListener, inject, input, output} from '@angular/core';
import {AuthService} from '../../autorization/auth/auth.service';
import {ActionEvent} from '../mobile-menu/mobile-menu/interfaces/action.interface';
import {Profile} from '../../core/interface/profile/profile.interface';
import {TabsInterface} from '../layout/interface/tabs.interface';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'quiz-header',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  public tabs = input<TabsInterface | undefined>();
  public profileInfo = input<Profile| undefined>();

  public action = output<ActionEvent>()
  private authService = inject(AuthService);
  public isAuth = this.authService.isAuthenticated()

  constructor(private el: ElementRef) {}

  public isActive = false
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const header = this.el.nativeElement.querySelector('.header');
    if (!header) return;

    if (window.pageYOffset > 0) {
      this.isActive = true
    } else {
      this.isActive = false
    }
  }

  public openMenu(){
    this.action.emit({type: 'open'});
  }

  public logout(){
    this.authService.logout()
  }
  public login(){
    if(this.isAuth) return
    this.authService.login()
  }

  protected readonly environment = environment;
}
